















































































































import {Component, Prop, Vue} from 'vue-property-decorator';
import {IMenuItem, MenuStore} from '../store/modules/menu.store';
import VueBootstrapTypeahead from 'vue-bootstrap-typeahead';
import CategoryHeader from '@/components/CategoryHeader.vue';
import ItemEdit from '@/components/ItemEdit.vue';
import AddExistingItem from '@/components/AddExistingItem.vue';
import ItemSearchResult from '@/components/ItemSearchResult.vue';
import {WebService} from '@/services/web.service';

@Component({
	components: {
		typeahead: VueBootstrapTypeahead,
		'category-header': CategoryHeader,
		'item-edit': ItemEdit,
		'add-existing-item': AddExistingItem,
		'item-search-result': ItemSearchResult
	}
})
export default class MenuEdit extends Vue {
	@Prop({required: true})
	menuId!: string;


	search = '';
	showOverlay = false;
	showLoading = false;
	showCompletedOverlay = false;
	overlayMessage = '';

	categoryName = '';

	selectedItemId: string | null = null;
	selectedCategoryId: number | null = null;
	showEditItem = false;
	showAddExistingItem = false;
	showCategoryLoading = false;

	editingMenu = false;
	showMenuLoading = false;
	menuName = '';

	get menu() {
		return MenuStore.menu(this.menuId);
	}

	get menus() {
		return MenuStore.menus;
	}

	created() {
		// if(this.badge !== null) {
		// 	this.badgeName = this.badge.name;
		// } else {
		// 	this.close();
		// }
	}

	close() {
		this.showOverlay = false;
	}

	finalClose() {
		this.$emit('close');
	}

	get items() {
		return MenuStore.itemsByMenu(this.menuId);
	}

	get validMenuName() {
		return this.menuName.trim() !== '' && this.menus.map((menu) => {
			return menu.name.toLowerCase();
		}).indexOf(this.menuName.trim().toLowerCase()) === -1;
	}

	serializeItem(input: {name: string}) {
		return input.name;
	}

	addExistingItem(categoryId: number) {
		this.selectedCategoryId = categoryId;
		this.showAddExistingItem = true;
	}

	addNewItem(categoryId: number) {
		this.selectedCategoryId = categoryId;
		this.selectedItemId = null;
		this.showEditItem = true;
	}

	itemsForCategory(categoryName: string) {
		return MenuStore.itemsForCategoryByMenu(this.menuId, categoryName);
	}

	get validCategoryName() {
		if(this.menu !== null) {
			return this.categoryName.trim() !== '' && this.menu.categories.map((category) => {
				return category.name.toLowerCase();
			}).indexOf(this.categoryName.trim().toLowerCase()) === -1;
		}
		return false;
	}

	async createCategory() {
		try {
			this.showCategoryLoading = true;
			await WebService.createCategory(this.menuId, {
				name: this.categoryName
			});
			this.showCategoryLoading = false;
			this.scrollToCategory(this.machineName(this.categoryName));
			this.categoryName = '';
		} catch(e) {
			this.showCategoryLoading = false;
			await this.$bvModal.msgBoxOk('There was a problem creating your category', {
				title: 'Error',
				centered: true,
				okTitle: 'Ok'
			});
		}
	}

	scrollToCategory(categoryName: string) {
		this.$nextTick(() => {
			(this.$refs[categoryName] as any)[0].scrollIntoView();
		});
	}

	machineName(name: string) {
		return name.replace(/ /g, '-').replace(/[^A-Za-z\-]/g, '').toLowerCase();
	}

	editItem(categoryId: number, item: IMenuItem) {
		this.selectedCategoryId = categoryId;
		this.selectedItemId = item.itemId;
		this.showEditItem = true;
	}

	// We don't know the categoryId because we are just searching raw items in the menu
	// if this turns out to be confusing/an issue then we can try to add opt-groups or
	// some indication of what category the items are in, the truth is that if the itemId
	// is the same then you are still editing the same underlying item, the categoryId
	// is really only there for NEW items (so we can attach the item to the category
	// after creation, it's not used for edit.
	typeaheadItemEdit(item: IMenuItem) {
		this.selectedCategoryId = -1; // Fake
		this.selectedItemId = item.itemId;
		this.showEditItem = true;
	}

	cancelMenuEdit() {
		this.editingMenu = false;
	}

	editMenu() {
		if(this.menu) {
			this.menuName = this.menu.name;
			this.editingMenu = true;
		}
	}

	async updateMenu() {
		if(this.menu) {
			try {
				this.showMenuLoading = true;
				await WebService.updateMenu({
					menuId: this.menuId,
					name: this.menuName
				});
				this.showMenuLoading = false;
				this.editingMenu = false;
			} catch(e) {
				this.showMenuLoading = false;
				await this.$bvModal.msgBoxOk('There was a problem updating your menu', {
					title: 'Error',
					centered: true,
					okTitle: 'Ok'
				});
			}
		}
	}

}
